const parseData = function(type) {
  if (type == "[]") return [];
  return {};
};
const Storage = {
  get(key, parseType) {
    let data = localStorage.getItem(key);
    try {
      if (data && parseType) {
        if(parseType === "integer"){
          data = parseInt(data)
        }
        else if(parseType === "float"){
          data = parseFloat(data)
        }
        else{
          data = JSON.parse(data);
        }
      }

      if (!data && parseType) {
        data = parseData(parseType);
      }
    } catch (err) {
      //config parse ex: "{}" or "[]"
      data = parseData(parseType);
    }

    return data || null;
  },
  set(key, value) {
    localStorage.setItem(key, value);
  },
  remove(key) {
    localStorage.removeItem(key);
  },
  clear(){
    localStorage.removeItem('userId');
    localStorage.removeItem('bearer');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
};

export default Storage;
